import { FC, ReactElement } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

export const VipTableLowBalanceConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const currentPopupData = usePopupSlice.currentPopupData();
  let messageData: string[] = [];
  if (currentPopupData !== null) {
    messageData = currentPopupData.messageData as string[];
  }

  const action: BlockingModalActionButton[] = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        dispatch(popupActions.dismissPopup(PopupType.VipTableLowBalance));
      },
    },
  ];

  return (
    <BlockingModalContent
      titleTk="LOWGAMEBALANCE"
      messageTk="LOBBY_PRIVATE_TABLE_LOW_BALANCE"
      messageData={messageData}
      actions={action}
    />
  );
};
